import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

import { TYPES } from './constants';

const Sub = ({ children, className, type, ...props }) => {
  const classes = classNames('Sub', className, {
    'Sub--inverse': type === TYPES.INVERSE,
  });

  return (
    <p className={classes} {...props}>
      {children}
      <style jsx>{`
        .Sub {
          font-weight: ${Theme.get('font-weight-normal')};
          line-height: 1.43;
          font-size: 14px;
          letter-spacing: 0.4px;
          margin: 0;
          padding: 0;
        }

        .Sub--inverse {
          color: ${Theme.get('colors-white')};
        }
      `}</style>
    </p>
  );
};

Sub.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  type: PropTypes.string,
};

Sub.defaultProps = {
  className: '',
  type: null,
};

export default Sub;
